<template>
  <div>
    <layout>
      <eoc-tabs
        v-show="selectedSideBarItem === 'patients'"
        :showing="selectedSideBarItem === 'patients'"
      />
      <providers
        v-show="selectedSideBarItem === 'providers'"
        :showing="selectedSideBarItem === 'providers'"
      />
      <supervision
        v-show="selectedSideBarItem === 'supervision'"
        :showing="selectedSideBarItem === 'supervision'"
      />
      <document-archive
        v-show="selectedSideBarItem === 'documents'"
        :showing="selectedSideBarItem === 'documents'"
      />
      <group-session
        v-show="selectedSideBarItem === 'groups'"
        :showing="selectedSideBarItem === 'groups'"
      />
      <utilization
        v-show="selectedSideBarItem === 'ur'"
        :showing="selectedSideBarItem === 'ur'"
      />
      <scheduler
        v-show="selectedSideBarItem === 'calendar'"
        :showing="selectedSideBarItem === 'calendar'"
      />
      <provider-availability
        v-show="selectedSideBarItem === 'availability'"
        :showing="selectedSideBarItem === 'availability'"
      />
      <case-load-records
        v-show="selectedSideBarItem === 'caseLoad'"
        :showing="selectedSideBarItem === 'caseLoad'"
      />
      <home
        v-show="selectedSideBarItem === 'dashboard'"
        :showing="selectedSideBarItem === 'dashboard'"
      />
      <mars
        v-show="selectedSideBarItem === 'mars'"
        :showing="selectedSideBarItem === 'mars'"
      />
      <occupancy
        v-show="selectedSideBarItem === 'bedBoard'"
        :showing="selectedSideBarItem === 'bedBoard'"
      />
      <billing
        v-show="selectedSideBarItem === 'billing'"
        :showing="selectedSideBarItem === 'billing'"
      />
      <eligibility
        v-show="selectedSideBarItem === 'eligibility'"
        :showing="selectedSideBarItem === 'eligibility'"
      />
      <appointment-request
        v-show="selectedSideBarItem === 'appointmentRequest'"
        :showing="selectedSideBarItem === 'appointmentRequest'"
      />
      <labs
        v-show="selectedSideBarItem === 'labs'"
        :showing="selectedSideBarItem === 'labs'"
      />
    </layout>
    <loading-overlay />
    <inactivity-overlay />
    <dialog-error />
    <eula v-if="showEulaModal" />
    <account-modal v-if="showAccountModal" v-model="showAccountModal" />
    <document-view-modal
      v-if="documentViewValue != null"
      v-model="documentViewValue"
      :documentId="documentViewValue.documentId"
      @onModify="onModifyDocumentView"
    />
    <document-add-edit-modal
      v-if="documentEditorValue"
      v-model="documentEditorValue"
      :formId="documentEditorValue.formId"
      :clientId="documentEditorValue.clientId"
      :eocId="documentEditorValue.eocId"
      :submitId="documentEditorValue.submitId"
      :initialEffectiveDateTime="documentEditorValue.initialEffectiveDateTime"
      :scheduleEventId="documentEditorValue.scheduleEventId"
      :scheduleEventParticipantId="
        documentEditorValue.scheduleEventParticipantId
      "
      :parentDocumentId="documentEditorValue.parentDocumentId"
      @onModify="onModifyDocumentEditor"
      :attachForm="documentEditorValue.attachForm"
      :hasAppointmentRelated="documentEditorValue.hasAppointmentRelated"
      :defaultValues="documentEditorValue.defaultValues"
    />
    <patient-search-result-modal
      v-if="showPatientsZohoModalValue"
      v-model="showPatientsZohoModalValue"
      :eocs="zohoEocs"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import LoadingOverlay from "./LoadingOverlay.vue";
import InactivityOverlay from "./InactivityOverlay.vue";
import DialogError from "../controls/DialogError.vue";
import Layout from "./Layout.vue";
import EocTabs from "../episode_of_care/EocTabs.vue";
import DocumentArchive from "../document_archive/DocumentArchiveIndex.vue";
import Scheduler from "../scheduler/SchedulerIndex.vue";
import ProviderAvailability from "../provider_availability/ProviderAvailabilityIndex";
import CaseLoadRecords from "../case_load/CaseLoadRecordsIndex.vue";
import GroupSession from "../group_session/GroupSessionIndex.vue";
import Utilization from "../utilization/UtilizationsIndex.vue";
import Home from "../home/HomeIndex.vue";
import Mars from "../mars/MarsIndex.vue";
import Occupancy from "../occupancy/OccupancyIndex.vue";
import Labs from "../labs/LabsIndex.vue";
import Eligibility from "../eligibility/EligibilityIndex.vue";
import Billing from "../billing/BillingIndex.vue";
import Eula from "./EULA.vue";
import DocumentViewModal from "../episode_of_care/document/DocumentViewModal.vue";
import AccountModal from "./MyAccountModal";
import AppointmentRequest from "../appointment_request/AppointmentRequestIndex.vue";
import Providers from "../providers/ProvidersIndex.vue";
import PatientSearchResultModal from "./PatientSearchResultModal.vue";
import Supervision from "../supervision/SupervisionIndex.vue";
import DocumentAddEditModal from "../episode_of_care/document/DocumentAddEditModal.vue";
export default {
  name: "WorkspaceIndex",
  components: {
    InactivityOverlay,
    LoadingOverlay,
    DialogError,
    Layout,
    EocTabs,
    Home,
    DocumentArchive,
    Scheduler,
    ProviderAvailability,
    CaseLoadRecords,
    GroupSession,
    Utilization,
    Mars,
    Occupancy,
    Labs,
    Eligibility,
    Billing,
    Eula,
    DocumentViewModal,
    AccountModal,
    AppointmentRequest,
    Providers,
    DocumentAddEditModal,
    PatientSearchResultModal,
    Supervision
  },
  data() {
    return {
      showEulaModal: false,
      showAccountModal: false
    };
  },
  async mounted() {
    const self = this;
    await this.fetchCurrentUser();
    const user = self.currentUser;
    if (!user.hasAcceptedEULA) {
      this.showEulaModal = true;
    } else if (!user.signature) {
      this.showAccountModal = true;
    }
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess", "fetchCurrentUser"]),
    ...mapMutations("layout", [
      "setDocumentView",
      "setShowPatientsZohoModal",
      "setDocumentEditor"
    ]),
    getComingSoonTitle(selectedSideBarItem) {
      return this.sidebarItems.find(item => item.key == selectedSideBarItem)
        .text;
    },
    onModifyDocumentView() {
      this.setDocumentView(null);
    },
    onModifyDocumentEditor() {
      this.setDocumentEditor(null);
    }
  },
  computed: {
    ...mapState("layout", {
      currentUser: state => state.currentUser,
      selectedSideBarItem: state => state.selectedSideBarItem,
      showPatientsZohoModal: state => state.showPatientsZohoModal,
      zohoEocs: state => state.zohoEocs,

      sidebarItems: state => [
        ...state.sidebarItemsStart,
        ...state.sidebarItemsEnd
      ],
      documentView: state => state.documentView,
      documentEditor: state => state.documentEditor
    }),
    documentViewValue: {
      get() {
        return this.documentView;
      },
      set() {}
    },
    documentEditorValue: {
      get() {
        return this.documentEditor;
      },
      set() {}
    },
    showPatientsZohoModalValue: {
      get() {
        return this.showPatientsZohoModal;
      },
      set(value) {
        this.setShowPatientsZohoModal(value);
      }
    }
  },
  watch: {
    selectedSideBarItem: {
      handler: function(value) {
        if (value === "dashboard") {
          this.$root.$emit("fetchNotifications");
        }
      },
      deep: true
    }
  }
};
</script>
